<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/cartloader";
    import { ModelListSelect } from "vue-search-select";
    import { mapActions, mapGetters, mapState } from "vuex";
    import Swal from "sweetalert2";
    import moment from "moment";
    /**
     * Form Layouts component
     */
    export default {
      page: {
        title: "Return Stock",
        meta: [{ name: "description", content: appConfig.description }],
      },
      components: { Layout, PageHeader, ModelListSelect,Loader, },
      data() {
        return {
          title: "Return Stock",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Return Stock",
              active: true,
            },
          ],
          selected: null,
          totalRows: 1,
    
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "product",
              sortable: true,
              label: "ITEM",
            },
            {
              key: "quantity_field",
              sortable: true,
              label: "QUANTITY",
            },            
            {
              sortable: true,
              key: "units",
              label: "UNITS",
            },
            {
              sortable: true,
              key: "actions",
              label: "ACTIONS",
            },
          ],
          existingItem: [],
          unitsArr: [],
    
          // Value from user input for adding position
          data: {
            product: "",
            unit: "",
            quantity: "",
            agent: '',
          },
          itemError: "",
          quantityError: "",
          unitError: "",
          totals: {            
            date: moment(new Date()).format("YYYY-MM-DD"),
          },

          // edit item
          editdata: {
            id: "",
            name: "",
            quantity: "",
          },

          // delete item
          deletedata: {
            name: "",
            id: "",
          },
          paidError: "",
          agentError:""
        };
      },
    
      computed: {
        // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
        ]),
        ...mapGetters("auth", ["MyUserPerm"]),
        ...mapGetters("products", ["Products"]),
        ...mapGetters("agentstock", ["Agents","StockreturnCart","SaveStatus","AgentStock"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.StockreturnCart ? this.StockreturnCart.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        this.totalRows = this.StockreturnCart ? this.StockreturnCart.length : 1;
      },
      watch: {
        show(newValue) {
          if (newValue == true) {
            if (this.type == "success") {
              this.closeModal(this.modal_id);
              Swal.fire("Success!", this.message.msg, "success");
            } else {
              Swal.fire("Error!", this.message.msg, "error");
            }
          }
        },

        StockreturnCart(newValue){
          if(newValue.length == 0){
            this.AgentStock = [];
          }else{
            this.FetchItems(this.StockreturnCart[0].agent.id); 
          }
        }        
      },
      methods: {
        ...mapActions({
          FetchAgents: "agentstock/fetchAgents",
          FetchCart: "agentstock/fetchStockreturnCart",
          AddCart: "agentstock/addToStockreturnCart",
          EditCart: "agentstock/editStockreturnCart",
          DeleteCart: "agentstock/deleteStockreturnCart",
          FetchItems: "agentstock/fetchAgentstock",
          SubmitItems: "agentstock/addReturnedstock",
        }),
    
        // COMMA SEPERATORS
        thousandSeprator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
              .toString()
              .replace(/\D/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
    
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
    
        
        assignArr(){
            let productID = this.data.product.split(' ')[0];
            let selectedPdt = this.AgentStock.filter((product)=>{
                return product.product_id == productID || product.code == productID;
            })
            this.unitsArr = selectedPdt[0].units;
            this.data.unit = this.unitsArr[0].id;
        },
    
        checkItem() {
          if (this.data.product != "") {
            let productID = this.data.product.split(' ')[0];
            this.existingItem = this.StockreturnCart.filter((item) => {
              return item.product_id == productID || item.code == this.data.product;
            });          
            
            if (this.existingItem.length) {
              this.itemError = "This Item already exists in cart";
            } else {
              this.itemError = "";
            }

            let selectedPdt = this.AgentStock.filter((product)=>{
                return product.product_id == productID || product.code == productID;
            })
            let tot = this.unitsArr.filter((unit)=>{
                return unit.id == this.data.unit;
            });
            let totEqv = tot[0].base_qty*this.data.quantity;
            if(selectedPdt[0].quantity < totEqv){
              this.quantityError = "Quantity entered is more than quantity in stock";              
            }
          } else {
            this.existingItem = [];
          }
        },
    
        resetData() {
          this.data.product = "";
          this.data.unit = "";
          this.data.quantity = "";
        },
        resetDeleteItem(modalId) {
          this.closeModal(modalId);
          this.deletedata.name = "";
          this.deletedata.id = "";
          this.modal_id = "";
        },
    
        resetEditSup(modalId) {
          this.closeModal(modalId);
          this.editsup.sup_id = "";
          this.modal_id = "";
        },
    
        resetEdit(modalId) {
          this.closeModal(modalId);
          this.editdata.name = "";
          this.editdata.id = "";
          this.editdata.quantity = "";
          this.modal_id = "";
        },
    
        resetErrors() {
          this.itemError = "";
          this.unitError = "";
          this.quantityError = "";
          this.agentError = "";
        },
    
        showEditModal(data) {
          this.editdata.product = data.product.id;
          this.editdata.name = data.product.product_name;
          this.editdata.id = data.id;
          this.editdata.quantity = data.quantity;
        },
    
        showDeleteModal(data) {
          this.deletedata.name = data.product.product_name;
          this.deletedata.id = data.id;
        },
        editItem(modalId) {
          this.modal_id = modalId;
          this.EditCart(this.editdata);
          this.focusProduct();
        },
    
        deleteItem(modalId) {
          this.modal_id = modalId;
          this.DeleteCart(this.deletedata);
          this.focusProduct();
        },
        Submit() {
            this.SubmitItems(this.totals);
            this.focusProduct();
        },
        resetAgentError() {
          this.agentError = "";
        },

        addToCart() {
          if (this.totals.agent == "") {
            this.agentError = "Agent field is required";
            return;
          } else {
            this.agentError = "";
          }
          if (this.data.product == "") {
            this.itemError = "Product is required";
            return;
          } else {
            this.itemError = "";
          }
          if (this.data.quantity == "") {
            this.quantityError = "Quantity Returned is required";
            return;
          } else {
            this.quantityError = "";
          }
          if (this.existingItem.length) {
            this.itemError = "This Item exists already please";
            return;
          } else {
            this.itemError = "";
          }
          this.checkItem();
          if(this.quantityError != ""){
            return;
          }
          this.data.product = this.data.product.split(' ')[0];
          this.AddCart(this.data);
          this.resetData();
          this.focusProduct();
        },

        FetchProducts(){
            this.FetchItems(this.data.agent); 
        },
        //== close modal
        closeModal(modalId) {
          this.$nextTick(() => {
            this.$bvModal.hide(modalId);
            this.resetData();
            this.resetErrors();
          });
        },

        nextPlease() {
          document.getElementById('input2').focus();
        },

        focusProduct() {
          this.$refs.cartProduct.focus();
        },

      },
      created() {
        this.FetchAgents();
        this.FetchCart();
        this.focusProduct();
        
      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Items in Cart</h4>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    class="datatables"
                    :items="StockreturnCart ? StockreturnCart : []"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
    
                    <template #cell(quantity_field)="data">
                      {{ data.item ? data.item.quantity : 0 }} {{ data.item ? data.item.unit : "---" }}
                    </template>
    
                    <template #cell(actions)="data">
                      <b-button-group>
                      <b-button
                        size="sm"
                        variant="primary"
                        v-b-modal.edit-item-modal
                        @click="showEditModal(data.item)"
                        ><i class="fa fa-edit"></i> Edit</b-button
                      >
                      <b-button
                        v-b-modal.delete-item-modal
                        variant="danger"
                        size="sm"
                        @click="showDeleteModal(data.item)"
                        ><i class="fa fa-trash"></i> Delete</b-button
                      >
                      </b-button-group>
                    </template>
                  </b-table>
                    
                </div>
                <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                </div>
                <Loader v-if="!StockreturnCart" />
                
                <b-form v-if="StockreturnCart?StockreturnCart.length > 0:false" class="mt-3">
                  <div class="row">                                       
                    <div class="col-md-4">
                      <div class="form-group mb-3">
                        <label>Date Sent</label>
                        <input
                          type="date"
                          class="form-control"
                          v-model="totals.date"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 mt-4">
                      <b-button variant="primary" class="float-end" @click="Submit()"
                        ><i class="fa fa-arrow-right"></i> Submit
                        <b-spinner
                          v-if="SaveStatus"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </b-button>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
    
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <form action="">
                    <div class="form-group mb-3" v-if="StockreturnCart?StockreturnCart.length == 0:false">
                        <label>Select Agent <span class="text-danger">*</span></label>
                        <model-list-select
                        :list="Agents ? Agents : []"
                        v-model="data.agent"
                        option-value="id"
                        option-text="name"
                        placeholder="Select Agent"
                        @input="FetchProducts(), resetAgentError()"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="agentError">
                            <em>{{ agentError }}</em>
                        </div>
                    </div> 
                  <div class="form-group mb-3">
                    <label>Product <span class="text-danger">*</span></label> 
                    <input
                    id="input1"
                    class="form-control"
                    v-model="data.product"
                    ref="cartProduct"
                    list="products"
                    placeholder="Select Product or Enter Barcode"
                    @input="resetErrors(),assignArr(), checkItem()"
                    v-on:keyup.enter="nextPlease() "
                    />
                    <datalist id="products">
                    <option
                        v-for="(pdt, p) in AgentStock"
                        :value="pdt.name1"
                        :key="p"
                    >
                    </option>
                    </datalist>                
                    <div class="text-danger" v-if="itemError">
                      <em>{{ itemError }}</em>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group mb-3">
                            <label>Quantity <span class="text-danger">*</span></label>
                            <input
                            type="number"
                            class="form-control"
                            step="any"
                            id="input2"
                            v-model="data.quantity"
                            @input="resetErrors()"
                            @keyup.enter="addToCart()"
                            placeholder="Enter Quantity"
                            />
                            <div class="text-danger" v-if="quantityError">
                            <em>{{ quantityError }}</em>
                            </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group mb-3">
                            <label>Unit Measure <span class="text-danger">*</span></label>
                            <model-list-select
                            :list="unitsArr ? unitsArr : []"
                            v-model="data.unit"
                            option-value="id"
                            option-text="unitsym"
                            placeholder="Select Unit"
                            @input="resetErrors()"
                            >
                            </model-list-select>
                            <div class="text-danger" v-if="unitError">
                            <em>{{ unitError }}</em>
                            </div>
                        </div>
                      </div>
                  </div>
                  
                  <div class="form-group text-center">
                    <b-button
                      @click="addToCart()"
                      variant="primary"
                      ><i class="fa fa-plus"></i> Add
                      <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Spinning"
                      ></b-spinner>
                    </b-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    
        <!-- modal edit item starts -->
        <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()"  header-bg-variant="warning">
          <template #modal-title>
            Edit Item {{ editdata.name }}</template
          >
          <div class="form-group mb-3">
            <label>Quantity</label>
            <input
              type="number"
              class="form-control"
              step="any"
              v-model="editdata.quantity"
            />
          </div>
          
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="closeModal('edit-item-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="editItem('edit-item-modal')"
            >
              <i class="fa fa-check"></i> Save Changes
              <b-spinner
                v-if="SaveStatus"
                variant="light"
                small
                label="Deleting"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
        <!-- modal delete expense starts -->
        <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" header-bg-variant="danger">
          <template #modal-title> Delete {{ deletedata.name }}</template>
          <div class="form-group mb-3">
            <div class="input-group">
              <h5>Do you want to remove this item? Click Proceed to continue.</h5>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="closeModal('delete-item-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteItem('delete-item-modal')"
            >
              <i class="fa fa-trash"></i> Proceed
              <b-spinner
                v-if="SaveStatus"
                variant="light"
                small
                label="Deleting"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
        <!-- modal ends -->
        <!--  end row -->
      </Layout>
    </template>
    <style>
    .btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>